// CMS API Client for G28 ApS
const API_BASE = 'https://api.dev.auxo.dk';

export async function fetchCollection(collectionName) {
  try {
    const res = await fetch(`${API_BASE}/public/v2/content/${collectionName}`);
    if (!res.ok) throw new Error(`Failed to fetch ${collectionName}`);
    const data = await res.json();
    return data.items || [];
  } catch (err) {
    console.warn(`CMS Fetch warning for ${collectionName}:`, err);
    return [];
  }
}

export async function fetchCollectionArray(collectionName) {
  try {
    const res = await fetch(`${API_BASE}/public/content/${collectionName}`);
    if (!res.ok) throw new Error(`Failed to fetch ${collectionName}`);
    return await res.json();
  } catch (err) {
    console.warn(`CMS Fetch array warning for ${collectionName}:`, err);
    return [];
  }
}

export async function fetchBySlug(slug) {
  try {
    const res = await fetch(`${API_BASE}/public/by-slug/${slug}`);
    if (!res.ok) throw new Error(`Failed to fetch slug ${slug}`);
    return await res.json();
  } catch (err) {
    console.warn(`CMS Fetch slug warning for ${slug}:`, err);
    return null;
  }
}
